const initialState = {
    blogs: [],
};

const athleteblogReducer = (state = initialState, action) => {
    switch (action.type) {

        case "BLOGDETAILS":
            return {
                ...state,
                blogs: action.payload,
            }


        default:
            return state;
    }
};
export default athleteblogReducer;
